<template>
  <el-container>
    <div class="about">
      <h1>This is an about page</h1>
    </div>

    <div>
      <treeselect
        v-model="value"
        :options="options"
        :multiple="true"
        placeholder="Select..."
      />
    </div>

    <div>
      <a-space wrap>
        <a-button type="primary">Primary Button</a-button>
        <a-button>Default Button</a-button>
        <a-button type="dashed">Dashed Button</a-button>
        <a-button type="text">Text Button</a-button>
        <a-button type="link">Link Button</a-button>
      </a-space>
    </div>

  </el-container>
  
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Button } from 'ant-design-vue';

export default {
  name: 'about',
  components: {
    AButton: Button,
    Treeselect,
  },
  data() {
    return {
        value: null,
        options: [
          {
            id: 1,
            label: 'Option 1',
            children: [
              { id: 2, label: 'Option 1.1' },
              { id: 3, label: 'Option 1.2' }
            ]
          },
          { id: 4, label: 'Option 2' }
        ]
    }
  }
}
</script>